// Form validation utilities for all submission types
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  // Remove all non-digit characters
  const cleanPhone = phone.replace(/\D/g, "");

  // Check if phone number is exactly 10 digits (US format with area code)
  return cleanPhone.length === 10;
};

export const formatPhoneNumber = (phone) => {
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, "");

  // Only format 10-digit US numbers as (XXX) XXX-XXXX
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6
    )}`;
  }

  // Return original phone number for any other length
  return phone;
};

export const validateForm = (formData, formType) => {
  const errors = {};

  // Common validations for all forms
  if (!formData.name || formData.name.trim().length === 0) {
    errors.name = "Name is required";
  }

  if (!formData.email || !validateEmail(formData.email)) {
    errors.email = "Please enter a valid email address";
  }

  if (!formData.phone || !validatePhone(formData.phone)) {
    errors.phone =
      "Please enter a valid 10-digit US phone number with area code";
  }

  // Form-specific validations
  switch (formType) {
    case "career":
      if (!formData.jobCategory) {
        errors.jobCategory = "Please select a job category";
      }
      break;

    case "parts":
      if (!formData.subject || formData.subject.trim().length === 0) {
        errors.subject = "Subject is required";
      }
      if (!formData.partType) {
        errors.partType = "Please select a part type";
      }
      if (!formData.details || formData.details.trim().length === 0) {
        errors.details = "Part details are required";
      }
      break;

    case "restoration":
      if (!formData.subject || formData.subject.trim().length === 0) {
        errors.subject = "Subject is required";
      }
      if (!formData.brandModel || formData.brandModel.trim().length === 0) {
        errors.brandModel = "Brand/Model is required";
      }
      if (!formData.description || formData.description.trim().length === 0) {
        errors.description = "Restoration goals are required";
      }
      break;

    default:
      break;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
